import ImageSlider from "../image-slider/image-slider";
import MarketingPage from "../marketing-page";
import "./blog.scss";
import BlogsDatabase from "./blogs-database";

const Blog = (props) => {
    const slug = props.match.params.slug;
    const blog = BlogsDatabase.find(blog => blog.slug === slug);
    return (
        <MarketingPage backLink={{ url: "/blogs", text: "Back to blogs" }}>

            <div className="case-study-name">{blog?.date}</div>
            <h1 className="">
                {blog?.title}
            </h1>
            <img className="blog-image" src={blog?.mainImage}></img>
            <div className="case-study-intro">
                {blog?.intro}
            </div>
            {blog?.content}
            {(blog?.images?.length || 0 > 0) &&
                <div className="image-container mt-1">
                    <ImageSlider images={blog?.images} />
                </div>}
        </MarketingPage>
    );
}

export default Blog;